import { Icon } from "icons";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { cn } from "ui";

import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";

import { MinimapItemBase } from "./MinimapItemBase";

interface MinimapExerciseItemProps {
  id: string;
  level: number;
  index: number;
  isLast: boolean;
  previousItemId?: string;
}

export const MinimapExerciseItem = observer(function MinimapExerciseItem(
  props: MinimapExerciseItemProps,
) {
  const { t } = useTranslation();
  const workoutEditStore = useWorkoutEditStore();
  const workoutItem = workoutEditStore.getWorkoutItemById(props.id);

  const displayName =
    workoutItem.exercise?.name ?? t("editWorkout.defaultGroupName");
  const setsCount = workoutEditStore.isInsideFreestyle(props.id)
    ? 0
    : workoutItem.workoutSets.length;

  return (
    <MinimapItemBase
      id={props.id}
      level={props.level}
      index={props.index}
      previousItemId={props.previousItemId}
      displayName={displayName}
      className={cn({
        "pt-2": props.index === 0 && !!workoutItem.parentId,
      })}
    >
      <span className="shrink-0">
        <Icon name="tabler-barbell" size={12} className="text-slate-400" />
      </span>
      <span className="text-xs truncate flex-1 min-w-0 text-slate-700">
        {displayName}
      </span>
      {setsCount > 0 ? (
        <span className="text-[10px] text-slate-400 shrink-0">
          x{setsCount}
        </span>
      ) : null}
    </MinimapItemBase>
  );
});
